import { privileges as userPrivileges } from "../config/userConfig";

export const getPrivilegesFromObject = (
  elementValue = {
    is_admin: false,
    is_packages: false,
    is_articles: false,
    is_clients: false,
    is_users: false,
  }
) => {
  const privileges = [];

  if (elementValue?.is_admin) {
    privileges.push(userPrivileges.admin);
  }
  if (elementValue?.is_packages) {
    privileges.push(userPrivileges.packages);
  }
  if (elementValue?.is_articles) {
    privileges.push(userPrivileges.articles);
  }
  if (elementValue?.is_clients) {
    privileges.push(userPrivileges.clients);
  }
  if (elementValue?.is_users) {
    privileges.push(userPrivileges.users);
  }

  return privileges;
};

export const getObjectFromPrivileges = (privilegesArray = []) => {
  const privileges = {};

  if (privilegesArray.includes(userPrivileges.admin)) {
    privileges["is_admin"] = true;
  }
  if (privilegesArray.includes(userPrivileges.packages)) {
    privileges["is_packages"] = true;
  }
  if (privilegesArray.includes(userPrivileges.articles)) {
    privileges["is_articles"] = true;
  }
  if (privilegesArray.includes(userPrivileges.clients)) {
    privileges["is_clients"] = true;
  }
  if (privilegesArray.includes(userPrivileges.users)) {
    privileges["is_users"] = true;
  }

  return privileges;
};
